export default __webpack_public_path__ + "static/media/Camargue.901260bb.jpg";